import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
    //加载所有modules
const files = require.context("./modules", false, /\.js$/);
const modules = files.keys().reduce((modules, file) => {
    // set './app.js' => 'app'
    const name = file.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = files(file)
    modules[name] = value.default
    return modules
}, {})

const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    user: state => state.user,
}
const store = new Vuex.Store({
    modules,
    getters,
    //   strict: process.env.NODE_ENV !== "production",
});
export default store